import { Loader } from '@gilbarbara/components';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

import './styles/app.scss';
import './styles/flex.scss';
import './styles/global.scss';
import './styles/layout.scss';
import './styles/reset.scss';
import './styles/scrollbar.scss';

import ErrorHandler from '~/components/ErrorHandler';
import GlobalStyles from '~/containers/GlobalStyles';

import { persistor, store } from '~/store';

import { PostHogConfig } from 'posthog-js';
import reportWebVitals from './reportWebVitals';
import Root from './Root';

window.store = store;

const { APP_ENV = '' } = process.env;

const options: Partial<PostHogConfig> = {
  api_host: process.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
};

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <PersistGate loading={<Loader block size={100} />} persistor={persistor}>
        <PostHogProvider apiKey={process.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
          <ErrorBoundary FallbackComponent={ErrorHandler}>
            <HelmetProvider>
              <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                <Root />
              </GoogleOAuthProvider>
            </HelmetProvider>
          </ErrorBoundary>
          <GlobalStyles />
        </PostHogProvider>
      </PersistGate>
    </Provider>,
  );
}

/* c8 ignore next 3 */
if (['local', 'development'].includes(APP_ENV)) {
  // eslint-disable-next-line no-console
  reportWebVitals(console.log);
}
